import { render } from "./Base.vue?vue&type=template&id=2714fb2c"
import script from "./Base.vue?vue&type=script&lang=js"
export * from "./Base.vue?vue&type=script&lang=js"

import "./Base.vue?vue&type=style&index=0&id=2714fb2c&lang=css"

import exportComponent from "C:\\Users\\jomon\\OneDrive\\Desktop\\algorithma-website-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__